import {
  Accordion,
  AccordionSection,
  ActionMenu,
  Heading,
  VisualSizesEnum,
} from '@frontapp/ui-kit';
import SiteInfo from './SiteInfo';
import CopyActionMenuItem from './menuItems/CopyActionMenuItem';
import { type SsoUser, levelEmoji } from './types';

type Props = {
  ssoUser: SsoUser;
};

// SSO users are not linked to an account: this card shows the projects where
// the email logs in with SSO.
function SsoUserInfo({ ssoUser }: Props) {
  return (
    <div
      style={{
        border: '1px solid var(--border-color)',
        padding: '15px',
        borderRadius: '5px',
        marginBottom: '10px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid var(--border-color)',
          marginBottom: '15px',
          paddingBottom: '15px',
        }}
      >
        <div style={{ flex: '1' }}>
          <Heading size={VisualSizesEnum.LARGE}>
            {levelEmoji[ssoUser.max_support_level]}
            <span style={{ paddingLeft: '10px' }}>
              🔑 {ssoUser.email} (SSO)
            </span>
          </Heading>
        </div>
        <ActionMenu width={220}>
          <CopyActionMenuItem title="Name" value={ssoUser.name} />
        </ActionMenu>
      </div>

      <Accordion>
        <AccordionSection
          id="sso-sites"
          title={`📚 Projects with SSO login (${ssoUser.sites.length})`}
          isOpen={true}
        >
          <table className="User__sites__table" style={{ margin: '15px 0' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Ownership</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {ssoUser.sites.map((site) => (
                <SiteInfo key={site.id} site={site} />
              ))}
            </tbody>
          </table>
        </AccordionSection>
      </Accordion>
    </div>
  );
}

export default SsoUserInfo;
